<template>
  <section v-if="linkError" class="m-t-30">
    <div class="container pitch-email">
      <div class="card has-text-centered">
        <div class="card-content">
          <h1 class="title is-4">{{ linkError.title }}</h1>
          <p>{{ linkError.message }}</p>
        </div>
      </div>
    </div>
  </section>
  <div v-else-if="email" :key="email.locked ? 'locked' : 'unlocked'">
    <PitchEmailView
      v-if="email.emailable_type === 'Wrios\\Models\\Pitch'"
      :email="email"
      v-on:reload="load"
    />
    <PitchGroupEmailView
      v-if="email.emailable_type === 'Wrios\\Models\\PitchGroup'"
      :email="email"
      v-on:reload="load"
    />
    <PlaylistEmailView
      v-if="email.emailable_type === 'Wrios\\Models\\Playlist'"
      :email="email"
      v-on:reload="load"
    />
    <SongEmailView
      v-if="email.emailable_type === 'Wrios\\Models\\Song'"
      :email="email"
      v-on:reload="load"
    />
    <UserWelcomeEmailView
      v-if="email.emailable_type === 'Wrios\\Models\\User'"
      :email="email"
      v-on:reload="load"
    />
  </div>
</template>

<script>
import { EMAIL_READ_BY_TOKEN } from '@/store/actions'
import { clearSharedLink, useSharedLink } from '@/services/sharedLink'

import PitchEmailView from './PitchEmailView'
import PitchGroupEmailView from './PitchGroupEmailView'
import PlaylistEmailView from './PlaylistEmailView'
import SongEmailView from './SongEmailView'
import UserWelcomeEmailView from './UserWelcomeEmailView'

const LINK_ERRORS = {
  404: {
    title: "This link isn't valid",
    message: 'Check that you have the whole link, or ask the person who sent it to share it again.'
  },
  410: {
    title: 'This link has expired',
    message: 'Ask the person who sent it to share it again.'
  }
}

export default {
  name: 'ExternalEmailShow',
  components: {
    PitchEmailView,
    PitchGroupEmailView,
    PlaylistEmailView,
    SongEmailView,
    UserWelcomeEmailView
  },

  data() {
    return {
      email: null,
      linkError: null
    }
  },

  created: function () {
    useSharedLink(this.$route.params.token)
    this.load()
  },

  beforeDestroy: function () {
    clearSharedLink()
  },

  beforeCreate: function () {
    document.body.className = 'pitch-view'
  },

  methods: {
    load() {
      let self = this
      this.$store.dispatch(EMAIL_READ_BY_TOKEN, this.$route.params.token)
        .then(function (data) {
          self.email = data
        }, function (err) {
          const status = err.response && err.response.status
          self.linkError = LINK_ERRORS[status] || null
          if (!self.linkError) {
            self.$store.commit('error', err)
          }
        })
    }
  }

}
</script>
